export default {"src":"/_next/static/media/ESTC.47eb30ab.svg","height":18,"width":18};